// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: initial !important;
}

.user-grid-item {
  padding-bottom: 5px;
  flex-direction: row;
  margin-top: 5px !important;

}

.user-grid-item-error {
  padding-bottom: 35px;
  flex-direction: row;
}

.user-text-box {
  width: 360px;
  height: 45px;
  border-radius: 5px;
  border: 1px solid #ACACAC;
  box-sizing: border-box;
}

.user-grid-item-error {
  padding-bottom: 35px;
  flex-direction: row;
}


.react-tel-input .form-control::placeholder {
  opacity: 0.6;
  font-size: 15px;
}

.PhoneInputInput:focus-visible {
  flex: 1 1;
  min-width: 0;
  border: 1px solid #006644 !important;
  outline: none;
}

.input-phone-number input:focus {
  outline: none !important;
  border: 10px solid #006644 !important;
  box-shadow: none !important;
}


.react-tel-input .form-control {
  width: 100% !important;
  height: 56px !important;
}

.react-tel-input {
  margin-top: 7px !important;
  width: 100%;
  border-radius: 4px;
}

.react-tel-input .country-list {
  max-height: 195px !important;
}

.react-tel-input .country-list {
  margin: 3px 0 10px -1px !important;

}

.input-phone-number input:hover {
  border-color: #006644 !important;
}

.input-phone-number input:focus {
  outline: none !important;
  border: 10px solid #006644 !important;
  box-shadow: none !important;
}

.react-tel-input:focus {
  border: 2px solid #009966;
  outline: none !important;
  box-shadow: 0 !important;

}

.user-dropdown:hover {
  border-color: #009966 !important;
  outline: 0px !important;
}

.rangeDatePicker:hover{
  border-color: #009966 !important;
}

/* .react-tel-input:hover {
  border: 1px solid #009966;

} */



/* .css-1lbgqgp-MuiInputBase-root-MuiOutlinedInput-root {
  margin-right: 24px;
  height: 45px;
} */
/* .css-1upilqn {
  margin-bottom: 0px !important;
} */

/* .css-1j1q8wo-MuiGrid-root {
  margin-top: -8% !important;
}

.css-1fkyx8n-MuiGrid-root {
  margin-top: -2% !important;
} */`, "",{"version":3,"sources":["webpack://./src/components/styles/users.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;;AAE5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,2BAA2B;AAC7B;;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;;AAEpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;;AAE1B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;GAGG;;;;AAIH;;;GAGG;AACH;;GAEG;;AAEH;;;;;;GAMG","sourcesContent":["p {\n  margin: initial !important;\n}\n\n.user-grid-item {\n  padding-bottom: 5px;\n  flex-direction: row;\n  margin-top: 5px !important;\n\n}\n\n.user-grid-item-error {\n  padding-bottom: 35px;\n  flex-direction: row;\n}\n\n.user-text-box {\n  width: 360px;\n  height: 45px;\n  border-radius: 5px;\n  border: 1px solid #ACACAC;\n  box-sizing: border-box;\n}\n\n.user-grid-item-error {\n  padding-bottom: 35px;\n  flex-direction: row;\n}\n\n\n.react-tel-input .form-control::placeholder {\n  opacity: 0.6;\n  font-size: 15px;\n}\n\n.PhoneInputInput:focus-visible {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #006644 !important;\n  outline: none;\n}\n\n.input-phone-number input:focus {\n  outline: none !important;\n  border: 10px solid #006644 !important;\n  box-shadow: none !important;\n}\n\n\n.react-tel-input .form-control {\n  width: 100% !important;\n  height: 56px !important;\n}\n\n.react-tel-input {\n  margin-top: 7px !important;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.react-tel-input .country-list {\n  max-height: 195px !important;\n}\n\n.react-tel-input .country-list {\n  margin: 3px 0 10px -1px !important;\n\n}\n\n.input-phone-number input:hover {\n  border-color: #006644 !important;\n}\n\n.input-phone-number input:focus {\n  outline: none !important;\n  border: 10px solid #006644 !important;\n  box-shadow: none !important;\n}\n\n.react-tel-input:focus {\n  border: 2px solid #009966;\n  outline: none !important;\n  box-shadow: 0 !important;\n\n}\n\n.user-dropdown:hover {\n  border-color: #009966 !important;\n  outline: 0px !important;\n}\n\n.rangeDatePicker:hover{\n  border-color: #009966 !important;\n}\n\n/* .react-tel-input:hover {\n  border: 1px solid #009966;\n\n} */\n\n\n\n/* .css-1lbgqgp-MuiInputBase-root-MuiOutlinedInput-root {\n  margin-right: 24px;\n  height: 45px;\n} */\n/* .css-1upilqn {\n  margin-bottom: 0px !important;\n} */\n\n/* .css-1j1q8wo-MuiGrid-root {\n  margin-top: -8% !important;\n}\n\n.css-1fkyx8n-MuiGrid-root {\n  margin-top: -2% !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
